export const CLIENT_REGISTRATION_TYPES = {
  AMBULATORY: 'ambulatory',
  INPATIENT: 'inpatient',
  PRELIMINARY: 'preliminary',
};

export const CLIENT_REGISTRATION_LABELS = {
  [CLIENT_REGISTRATION_TYPES.AMBULATORY]: 'Амбулаторный',
  [CLIENT_REGISTRATION_TYPES.INPATIENT]: 'Стационарный',
  [CLIENT_REGISTRATION_TYPES.PRELIMINARY]: 'Предварительная запись',
};
